import React, { useState } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
// @ts-ignore
import ReactIsCapsLockActive from '@matsun/reactiscapslockactive';
import { useSharedStyles } from '../../../sharedStyles/Styles';
import { useStyles } from './Styles';
import { useTranslation } from 'react-i18next';
import { FormHelperText, Grid, InputAdornment, InputLabel, TextField } from '@material-ui/core';

export interface PasswordFieldProps {
  name: string;
  error?: string | null;
  register?: UseFormRegisterReturn;
}

export const PasswordField = ({ name, error, register }: PasswordFieldProps) => {
  const classes = useStyles();
  const sharedClasses = useSharedStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordClass, setShowPasswordClass] = useState(sharedClasses.eyeInactive);
  const { t } = useTranslation();

  const onSelect = () => {
    setShowPassword(!showPassword);
    setShowPasswordClass(
      !showPassword ? sharedClasses.eyeActive : sharedClasses.eyeInactive
    );
  };

  const onFocus = () => {
    setShowPasswordClass(sharedClasses.eyeHover);
  };

  const onBlur = () => {
    setShowPasswordClass(
      showPassword ? sharedClasses.eyeActive : sharedClasses.eyeInactive
    );
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <InputLabel shrink required >
          {t('login_signup.password.label')}
        </InputLabel>
      </Grid>
      <Grid item xs={12}>
        <TextField
          className={classes.field}
          name={name}
          autoComplete='password'
          type={showPassword ? 'text' : 'password'}
          fullWidth
          inputRef={register?.ref}
          onChange={register?.onChange}
          onBlur={register?.onBlur}
          inputProps={{ 'data-testid': 'password-field' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <i
                  role='button'
                  tabIndex={0}
                  className={showPasswordClass}
                  onClick={onSelect}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onSelect();
                    }
                  }}
                  onMouseOver={onFocus}
                  onFocus={onFocus}
                  onMouseOut={onBlur}
                  onBlur={onBlur}
                />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <ReactIsCapsLockActive>
        {(isActive: boolean) => isActive && (
          <Grid item xs={12}>
            <FormHelperText error data-testid='caps-lock-warning'>{t('caps_lock_on')}</FormHelperText>
          </Grid>
        )}
      </ReactIsCapsLockActive>
      {error && (
        <Grid item xs={12}>
          <FormHelperText error data-testid='password-error'>{error}</FormHelperText>
        </Grid>
      )}
    </Grid>
  );
};
